import { useEffect } from "react";

import pkg from "../../package.json";

export const useServiceVersion = () => {
	useEffect(() => {
		const currentVersion = pkg.version;

		const savedVersion = localStorage.getItem("app_version");

		if (savedVersion && savedVersion !== currentVersion) {
			localStorage.setItem("app_version", currentVersion);
			window.location.reload(); // Força reload com arquivos novos
		} else {
			localStorage.setItem("app_version", currentVersion);
		}

		if (!savedVersion) {
			window.location.reload(); // Força reload com arquivos novos
		}
	}, []);
};
